import { compileRoutes } from "@workflows/runtime-web";

export const routes = compileRoutes({
  "files.index": (_?: unknown) => "/files",
  "file.index": (_: { fileId: string }) => "/files/:fileId",
});
